import React, { useEffect, useState } from "react";

// MUI
import { DataGrid } from "@mui/x-data-grid";
import { Box, Stack } from "@mui/material";

// Local
import { tableStyle } from "../../theme";
import SubSettingsHeader from "../../components/UI/SubSettingsHeader";
import useApiHttp from "../../hooks/use-http";
import { isoToInformalData } from "../../util/helper";
import { Button, Icon, Text } from "@jds/core";
import EmptyState from "../../components/NoData/EmptyState";
import Loader from "../../components/UI/Loader/Loader";

export default function SubscriptionOrderHistoryPage() {
  const [invoiceListData, setInvoiceListData] = useState([]);
  const { sendRequest: getInvoiceList, isLoading: isInvoiceListLoading } =
    useApiHttp();
  const { sendRequest: downloadInvoiceApi, isLoading: isInvoiceDownloading } =
    useApiHttp();
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });

  const columns = [
    { field: "s_no", headerName: "S.No", width: 100, sortable: false },
    {
      field: "planName",
      headerName: "Plan Name",
      width: 180,
      sortable: false,
      renderCell: (val) => {
        return (
          <Text
            text={val?.row?.invoiceItems?.[0].planName}
            appearance="body-s"
          />
        );
      },
    },
    {
      field: "invoiceId",
      headerName: "Invoice Id",
      width: 200,
      sortable: false,
      renderCell: (val) => {
        return <Text text={val?.row?.invoiceNumber} appearance="body-s" />;
      },
    },
    {
      field: "planStartDate",
      headerName: "Start Date",
      width: 150,
      sortable: false,
      renderCell: (val) => {
        return (
          <Text
            text={isoToInformalData(val?.row?.planStartDate)}
            appearance="body-s"
          />
        );
      },
    },
    {
      field: "planEndDate",
      headerName: "End Date",
      width: 150,
      sortable: false,
      renderCell: (val) => {
        return (
          <Text
            text={isoToInformalData(val?.row?.planEndDate)}
            appearance="body-s"
          />
        );
      },
    },

    {
      field: "amount",
      headerName: "Amount",
      width: 100,
      sortable: false,
      renderCell: (val) => {
        return <Text text={"₹" + val?.row?.amount} appearance="body-s" />;
      },
    },
    {
      field: "tax",
      headerName: "Tax",
      width: 100,
      sortable: false,
      renderCell: (val) => {
        return <Text text={"₹" + val?.row?.tax} appearance="body-s" />;
      },
    },
    {
      field: "amountPaid",
      headerName: "Total",
      width: 100,
      sortable: false,
      renderCell: (val) => {
        return <Text text={"₹" + val?.row?.amountPaid} appearance="body-s" />;
      },
    },
    {
      field: "download",
      headerName: "Download",
      width: 150,
      sortable: false,
      renderCell: (val) => {
        return (
          <Stack
            direction="row"
            alignItems={"center"}
            sx={{ cursor: "pointer", gap: "4px" }}
            onClick={() => {
              if (!isInvoiceDownloading) {
                downloadInvoicehandler(val?.row?.invoiceId);
              } else {
                console.log("hello");
              }
            }}
          >
            <Icon ic="IcDocument" />
            <Text
              text={"Download"}
              color="primary_60"
              appearance="body_s_bold"
            />
          </Stack>
        );
      },
    },
  ];
  const getInvoiceListHandler = (page, size) => {
    getInvoiceList(
      {
        url: `chargeit/get-invoices?page=${page}&size=${size}`,
        base: "MEDIA",
      },
      () => { },
      (data) => {
        if (Array.isArray(data?.data)) {
          setInvoiceListData(data?.data);
          const updateData = data?.data || [];
          setRows(
            updateData.map((item, i) => {
              return { ...item, s_no: i + 1 + page * size, id: i };
            })
          );
          setRowCount(data?.count);
        } else {
          setRows([]);
        }
      },
      (err, data) => { }
    );
  };
  const downloadInvoicehandler = (invoiceId) => {
    downloadInvoiceApi(
      {
        url: `chargeit/download-invoice?InvoiceId=${invoiceId}`,
        base: "MEDIA",
      },
      () => { },
      (data) => {
        const link = document.createElement("a");
        link.href = data?.data?.invoiceUrl;
        link.click();
      },
      (err, data) => { }
    );
  };
  const handlePagination = (e) => {
    getInvoiceListHandler(e.page, e.pageSize);
  };
  useEffect(() => {
    getInvoiceListHandler(0, 25);
  }, []);

  return (
    <div>
      <SubSettingsHeader heading="Order History" />

      <div
        style={{
          height: "calc(100vh - 300px)",
          width: "100%",
          maxWidth: '1158px',
          marginTop: "32px",
        }}
      >
        <DataGrid
          columns={columns}
          rows={Array.isArray(rows) ? rows : []}
          rowCount={rowCount}
          disableColumnMenu
          disableRowSelectionOnClick
          loading={isInvoiceListLoading}
          sx={{
            ...tableStyle,
            "& .MuiDataGrid-cell:focus": {
              outline: "none", // This removes the active border on focus
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none", // This removes the active border on focus
            },
            // Scrollbar Styling
            "& .MuiDataGrid-virtualScroller": {
              "&::-webkit-scrollbar": {
                width: "8px", // Width of the scrollbar
                height: "8px", // Height for horizontal scrollbar
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.3)", // Color of the thumb
                borderRadius: "10px", // Optional: round the thumb
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1", // Track color
              },
              // Firefox styling
              scrollbarWidth: "thin", // Thin scrollbar
              scrollbarColor: "rgba(0, 0, 0, 0.3) #f1f1f1", // Thumb and track colors
            },
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          pageSizeOptions={[25, 50, 75, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={(e) => {
            setPaginationModel(e);
            handlePagination(e);
          }}
        />
      </div>
    </div>
  );
}
